

const InstallmentSvg = ({className}) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
       className={className}
    >
      <path
        d="M3.8623 1.5V16.5"
        stroke="#6C7278"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.8623 3H12.2623C14.2873 3 14.7373 4.125 13.3123 5.55L12.4123 6.45C11.8123 7.05 11.8123 8.025 12.4123 8.55L13.3123 9.45C14.7373 10.875 14.2123 12 12.2623 12H3.8623"
        stroke="#6C7278"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InstallmentSvg;
